import './overview.css'
import React from 'react';

//import pick1 from '../pictures/Image 556.png'
import google from '../pictures/Image 558.png'
//import map from '../pictures/map.png'
import { Card, CardImg, CardText, CardBody, CardTitle } from 'reactstrap';
import school from '../pictures/school.png'
import connect from '../pictures/connect.png'
import office from '../pictures/office.png'
import medical from '../pictures/medical.png'

function Third() {
    return (
        <div className="third">
            <div className="color"></div>
            <div className="second">
                <div className="fine">FINEST FOR FINESTS</div>
                <div className="fineWords"><p>Elevate is the brainchild of two industry stalwarts -
                pan-India developer, Conscient and global giant, Hines. Teaming up with this formidable
                    duo, Tata Projects now joins them as a construction part</p></div>
            </div>
            <div className="OverView">
                <div id="txt">Overiew</div>
                <div className="strategy">Strategic Location That Uplifts You</div>
                <div className="strategy_text"><p>Located off the Golf Course Extension Road,
                sans traffic and dust, with direct connectivity from both Delhi and Gurugram,
                    Elevate enjoys lush views of the Aravallis in a premium upscale neighbourhood.</p></div>
                <div className="google_button">
                    <img src={google} alt="" />
                    <div >View Google Map</div>
                </div>
            </div>
            <div className="picture">
            </div>
            <div className="cardBlock">
                <Card className="first1">
                    <CardImg top width="100%" src={school} alt="Card image cap" />
                    <CardBody>
                        <hr />
                        <CardTitle>Schools</CardTitle>
                        <hr />
                        <CardText>
                            <ul>
                                <li><span className="black">Heritage School</span> - 5 mins </li>
                                <li><span className="black" >DPS International School</span> - 5 min</li>
                                <li><span className="black">Heritage School</span> - 5 mins</li>
                            </ul>
                        </CardText>
                    </CardBody>
                </Card><Card className="first2">
                    <CardImg top width="100%" src={connect} alt="Card image cap" />
                    <CardBody>
                        <hr />
                        <CardTitle>Connectivity</CardTitle>
                        <hr />
                        <CardText>
                        <ul>
                                <li><span className="black">Heritage School</span> - 5 mins </li>
                                <li><span className="black" >DPS International School</span> - 5 min</li>
                                <li><span className="black">Heritage School</span> - 5 mins</li>
                            </ul>
                        </CardText>

                    </CardBody>
                </Card>
                <Card className="first3">
                    <CardImg top width="100%" src={office} alt="Card image cap" />
                    <CardBody>
                        <hr />
                        <CardTitle>Offices</CardTitle>
                        <hr />
                        <CardText>
                        <ul>
                                <li><span className="black">Heritage School</span> - 5 mins </li>
                                <li><span className="black"> DPS International School </span>- 5 min</li>
                                <li><span className="black">Heritage School</span> - 5 mins</li>
                            </ul>
                        </CardText>

                    </CardBody>
                </Card>
                <Card className="first4">
                    <CardImg top width="100%" src={medical} alt="Card image cap" />
                    <CardBody>
                        <hr />
                        <CardTitle>Medical facilities</CardTitle>
                        <hr />
                        <CardText>
                        <ul>
                                <li><span className="black">Heritage School</span> - 5 mins </li>
                                <li><span className="black" >DPS International School</span> - 5 min</li>
                                <li><span className="black">Heritage School</span> - 5 mins</li>
                            </ul>
                        </CardText>

                    </CardBody>
                </Card>
            </div>
            
           
            
        </div>
    );
}

export default Third